<script>
	import {replace} from "svelte-spa-router";
	import {onMount} from "svelte";
	import Controlador from "../controlador.svelte";
	import {logueo} from "../store";	
	let c;
	let password = "";
	let user = "";
	let mensaje = "";
	async function login(){
		if (user.trim() == "arteaflordepiel" && password.trim() == "solyvalen"){
			$logueo = true;
			replace("/home");
		} else {
			mensaje = "contraseña o usuario incorrecto/s";
			password = "";
			user = "";
		}
	}
	onMount(()=>{
		c.conectar();
	})
</script>
<Controlador bind:this={c} />
<div class="p-4 w-full h-full flex items-center justify-center">
	<div class="w-full sm:w-1/4 flex flex-col items-center justify-center bg-white rounded shadow">
		<div class="mt-8 w-1/3 flex items-center justify-center rounded-full overflow-hidden">
			<img src="logo.jpeg" alt="logo" />
		</div>	
		<p class="text-sm font-bold m-2 p-2 text-red-400">{mensaje}</p>
		<input bind:value={user} class="w-3/4 mb-2 p-2" type="text" placeholder="Cuenta" />
		<input bind:value={password} class="w-3/4 m-2 p-2" type="password" placeholder="Contraseña" />
		<button on:click={login} class="m-2 p-2 bg-red-500 rounded shadow text-white cursor-pointer hover:bg-red-300">Ingresar</button>
	</div>
</div>
